import { render, staticRenderFns } from "./StoreReferences.vue?vue&type=template&id=80c74eec&scoped=true&"
import script from "./StoreReferences.vue?vue&type=script&lang=ts&"
export * from "./StoreReferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c74eec",
  null
  
)

export default component.exports